import React, { useEffect} from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import Menu from '../Menu';
import useBootstrapCollapse from '../../../util/useBootstrapCollapse';
import config from '../../../config/config';
import LanguageSwitcher from './LanguageSwitcher';
import NavbarSearchForm from '../../filter/NavbarSearchForm';
import SideDrawer from '../SideDrawer';
import BackDrop from '../BackDrop';
import {useTranslation} from '../../../config/TranslationProvider';

const Navbar = () => {
    const {pathname} = useLocation();
    const {collapseRef, collapseSizeRef, showCollapse, setShowCollapse, toggleCollapse, collapseClassNames} = useBootstrapCollapse();

    const closeSideDrawerRef = React.useRef(null);
    const openSideDrawerRef = React.useRef(null);

    const onToggleCollapse = (event) => {
        if (!showCollapse) {
            closeSideDrawerRef?.current.focus();
        } else {
            openSideDrawerRef?.current.focus();
        }

        toggleCollapse(event);
    };

    // Disable scrolling while mobile menu is open
    useEffect(() => {
        if (showCollapse) {
            document.body.style.overflowY = 'hidden';
        } else {
            document.body.style.overflowY = null;
        }
    }, [showCollapse]);

    // Hide navbar on location changes
    useEffect(() => {
        if (showCollapse) {
            setShowCollapse(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);

    const {images, links} = config;
    let linksCopy = JSON.parse(JSON.stringify(links.header));
    delete linksCopy.host_area;

    return (
        <div className="mainmenu-wrapper" id="main-menu" role="navigation">
            <SideDrawer
                links={links.header}
                pos="sideDrawer"
                classes={collapseClassNames}
                click={onToggleCollapse}
                ref={closeSideDrawerRef}
            />
            {(collapseClassNames === 'collapse show') && <BackDrop click={onToggleCollapse} />}
            <div className="menu-area menu1 menu--light">
                <div className="top-menu-area">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="menu-fullwidth">
                                    <div className="logo-wrapper order-sm-0 order-1">
                                        <div className="logo logo-top">
                                            <NavLink to="/" aria-label={useTranslation('homepage')}>
                                                <img src={images.logos.header} alt="Stadt Dresden Logo" className="img-fluid navbar-logo" />
                                            </NavLink>
                                        </div>
                                    </div>
                                    <div className="menu-container order-sm-1 order-0">
                                        <div className="d_menu">
                                            <nav className="navbar navbar-expand-sm mainmenu__menu">
                                                <button
                                                    className="navbar-toggler"
                                                    type="button"
                                                    aria-controls="direo-navbar-collapse"
                                                    aria-expanded={showCollapse ? 'true' : 'false'}
                                                    aria-label={useTranslation('navigation_open_close')}
                                                    onClick={onToggleCollapse}
                                                    ref={openSideDrawerRef}
                                                >
                                                    <span className="navbar-toggler-icon icon-menu">
                                                        <i className="la la-reorder" />
                                                    </span>
                                                </button>
                                                <div
                                                    id="direo-navbar-collapse"
                                                    ref={collapseRef}
                                                    className={'navbar-collapse ' + collapseClassNames}
                                                >
                                                    {/* Remove host area link for sm to md */}
                                                    <ul className="navbar-nav all-links" ref={collapseSizeRef}>
                                                        <Menu links={links.header} pos="header" />
                                                    </ul>
                                                    <ul className="navbar-nav link-removed" ref={collapseSizeRef}>
                                                        <Menu links={linksCopy} pos="header" />
                                                    </ul>
                                                </div>
                                            </nav>
                                        </div>
                                    </div>
                                    <div className="menu-right order-sm-2 order-2">
                                        <NavbarSearchForm className="desktop-menu" />

                                        <LanguageSwitcher />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Navbar;
